/**
 * The calendar day a moment falls on **in Asia/Jakarta**, as `YYYY-MM-DD`.
 *
 * Used to bucket notification roll-ups. A UTC day boundary would split a Jakarta
 * evening across two buckets (UTC+7 puts 07:00 Jakarta at 00:00 UTC), so a teacher
 * grading after 17:00 would start a second card for the same day.
 *
 * `en-CA` is the shortest route to a zero-padded ISO-ordered date; formatting parts by
 * hand would be the same output with more places to get the padding wrong.
 */
export const getJakartaDayKey = (date: Date = new Date()): string =>
  new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Jakarta',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date)
